import {createRouter, createWebHistory} from "@ionic/vue-router";
import {NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw} from "vue-router";
import MiddlewareBase from "@/router/middleware/MiddlewareBase";
import adminRoutings from "@/router/route/adminRoutings";
import moduleRoutings from "@/router/route/moduleRoutings";
import AuthMiddleware from "@/router/middleware/AuthMiddleware";

const routes: Array<RouteRecordRaw> = [

    {
        path: "/index.html",
        redirect: "/home",
    },
    {
        name: "welcome",
        path: "/welcome",
        component: () => import("@/views/WelcomePage.vue"),
    },
    {
        name: "maintenance",
        path: "/maintenance",
        component: () => import("@/views/MaintenancePage.vue"),
    },
    {
        path: "/modules",
        component: () => import("@/components/navigation/Navigation.vue"),
        children: [
            /*----- module access denied -----*/
            {
                name: "moduleAccessDenied",
                path: "access-denied",
                component: () => import("@/views/errors/ModuleAccessDenied.vue"),
            },
        ],
    },
    {
        path: "/",
        component: () => import("@/components/navigation/Navigation.vue"),
        redirect: "/home",
        children: [
            /*----- dashboard -----*/
            {
                name: "home",
                path: "home",
                component: () => import("@/views/DashboardPage.vue"),
            },
            {
                name: "profile",
                path: "profile",
                component: () => import("@/views/account/AccountPage.vue"),
            },

            /*----- notifications -----*/
            {
                name: "notifications",
                path: "notifications",
                component: () => import("@/views/notifications/NotificationsPage.vue"),
                meta: {
                    middleware: [new AuthMiddleware()],
                },
            },
            /*----- settings -----*/
            {
                name: "settings",
                path: "settings",
                component: () => import("@/views/SettingsPage.vue"),
            },

            /*----------------------*/
            /*-- module routings ---*/
            /*----------------------*/
            ...moduleRoutings,

            /*----------------------*/
            /*-- account routings --*/
            /*----------------------*/
            /*
            {
                name: "account",
                path: "account",
                component: () => import("@/views/account/AccountPage.vue"),
                meta: {
                    middleware: [new AuthMiddleware()],
                },
            },
            
             */
        ],
        // default middleware if not specified
        meta: {
            middleware: [new AuthMiddleware()],
        },
    },

    /*----------------------*/
    /*--- admin routings ---*/
    /*----------------------*/
    ...adminRoutings,
    /*----------------------*/
    /*-------- debug -------*/
    /*----------------------*/
    {
        path: "/paus-debug",
        component: () => import("@/components/navigation/Navigation.vue"),
        children: [
            /*----- module access denied -----*/
            {
                name: "paus-debug",
                path: "",
                component: () => import("@/views/DebugPage.vue"),
            },
        ],
    },
    {
        path: "/paus-debug2",
        component: () => import("@/components/navigation/Navigation.vue"),
        children: [
            /*----- module access denied -----*/
            {
                name: "paus-debug2",
                path: "",
                component: () => import("@/views/DebugPage2.vue"),
            },
        ],
    },
    {
        path: "/paus-debug3",
        component: () => import("@/components/navigation/Navigation.vue"),
        children: [
            /*----- module access denied -----*/
            {
                name: "paus-debug3",
                path: "",
                component: () => import("@/views/DebugPage3.vue"),
                meta: {
                    middleware: [new AuthMiddleware()],
                },
            },

        ],
    },
    /*----------------------*/
    /*--- error routings ---*/
    /*----------------------*/
    {
        name: "notFound",
        path: "/:catchAll(.*)",
        component: () => import("@/views/errors/NotFound.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
});

router.onError((error: any) => {
    console.log("routing error: ", error);
});
router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    if (!to.meta.middleware) {
        return next();
    }

    /*----- navigation middlewares -----*/
    const middlewares = to.meta.middleware as MiddlewareBase[];

    for (const middleware of middlewares) {
        if (!(await middleware.execute(to, from, next))) {
            return;
        }
    }
    next();
});

router.afterEach(async (to, from, failure ) => {
   console.log(failure);
});

export default router;
